import { useInfiniteQuery } from "@tanstack/react-query";
import { ChatsQueryKeys } from "./chatsQueryKeys";
import { getChatsPaginated } from "@/api/chats";

const PAGE_SIZE = 30;

interface UseInfiniteChatsParams {
  search?: string;
}

/**
 * Paginated, infinite-scroll chat list. Backed by the same query key as the
 * paginated endpoint so the socket layer's `invalidateChats` refreshes it.
 * Pages are loaded on demand (see the virtualizer's near-end trigger) so the
 * heavy per-row subqueries only run for the visible slice, not every chat.
 */
export const useInfiniteChats = (params?: UseInfiniteChatsParams) => {
  return useInfiniteQuery({
    queryKey: [ChatsQueryKeys.ChatsPaginated, params],
    queryFn: ({ pageParam, signal }) =>
      getChatsPaginated({
        signal,
        params: { ...params, page: pageParam, pageSize: PAGE_SIZE },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.currentPage < lastPage.meta.totalPages
        ? lastPage.meta.currentPage + 1
        : undefined,
  });
};
